<template>
  <div>
    <!-- <v-container fluid> -->
    <v-layout justify-center>
      <v-flex
        xs12
        sm12
        md10
        lg5
        xl5
      >
        <div class="payment-card">
          <div class="payment-card-title d-flex align-center">
            Pay with
            <div class="pl-2">
              <img
                src="../../../assets/images/qi.svg"
                style="width: 100px; height: 30px; object-fit: contain"
              >
            </div>
          </div>
          <div class="payment-card-body">
            <form
              v-if="!qiResponse.data.paymentId"
              @submit.prevent="submitForm()"
            >
              <v-layout wrap>
                <v-flex xs12>
                  <v-text-field
                    label="Amount"
                    v-model="form.amount_usd"
                    :error-messages="errors.collect('Amount')"
                    v-validate="'required'"
                    data-vv-name="Amount"
                    type="number"
                    step="0.01"
                    min="0.2"
                    prepend-icon="attach_money"
                    @input="calcAmount()"
                  />
                </v-flex>

                <v-flex xs12>
                  <div style="font-size: 16px">
                    <span>Minimum amount <b>($0.2)</b> or <b>(IQD250)</b></span>
                  </div>
                </v-flex>

                <v-flex
                  v-if="form.amount"
                  xs12
                >
                  <div style="font-size: 16px">
                    <span>Amount in IQD is:</span>
                    <span style="padding-left: 6px">IQD{{ form.amount.toLocaleString() }}</span>
                  </div>
                </v-flex>

                <v-flex
                  xs12
                  class="py-4"
                >
                  <v-btn
                    style="height: auto"
                    color="primary"
                    depressed
                    type="submit"
                    :loading="loading"
                    :disabled="!form.amount || form.amount < 250"
                  >
                    Next
                  </v-btn>
                </v-flex>
              </v-layout>
            </form>
          </div>
        </div>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import Axios from 'axios'
export default {
  data() {
    return {
      loading: false,
      exRate: 0,
      form: {
        amount_usd: null,
        amount: null,
        currency: 'IQD'
      },
      qiResponse: {
        access_token: null,
        data: {
          paymentId: null
        }
      }
    }
  },

  mounted() {
    this.getLastExRate()
  },

  methods: {
    calcAmount() {
      this.form.amount = Number(this.form.amount_usd) * Number(this.exRate)
      this.form.amount = Math.round(this.form.amount)
      this.form.amount = parseInt(this.form.amount)
    },

    tryAgain() {
      this.qiResponse = {
        access_token: null,
        data: {
          paymentId: null
        }
      }
    },

    getLastExRate() {
      let token = localStorage.getItem('access_token')
      Axios.get('api/currency-rate/latest', { headers: { Authorization: 'Bearer ' + token } }).then(res => {
        this.exRate = res.data.ex_rate
      })
    },

    submitForm() {
      this.$validator.validateAll().then(() => {
        this.loading = true
        let token = localStorage.getItem('access_token')
        Axios.post('api/pay-with-qi', this.form, { headers: { Authorization: 'Bearer ' + token } }).then(res => {
          this.qiResponse = res.data
          if (this.qiResponse.status === 'CREATED') {
            window.open(this.qiResponse.formUrl, '_blank')
            this.$router.push('/charge-balance')
          }
        }).finally(() => {
          this.loading = false
        })
      })
    }
  }
}
</script>

<style>
.payment-card {
  border: 1px solid #ddd;
  margin-top: 16px;
  padding: 16px;
  border-radius: 8px;
}
.payment-card-title {
  font-size: 20px;
  font-weight: 500;
}
.payment-currency-btn .btn__content {
  width: 60px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/customer/payWithQi.vue